import AdvanceTableWrapper from 'components/common/advance-table/AdvanceTableWrapper';
import React, { useState } from 'react';
import { Button, Card, Col, Form, Modal, Row, Spinner, Badge } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableSearchBox from 'components/common/advance-table/AdvanceTableSearchBox';
import FalconCloseButton from 'components/common/FalconCloseButton';
import IconButton from 'components/common/IconButton';
import PageHeader from 'components/common/PageHeader';
import SoftBadge from 'components/common/SoftBadge';
import useToken from 'hooks/useToken';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useToast } from 'context/providers/ToastProvider';

const FacturaDocumentosGuatemala = () => {
    const columns = [
        {
            accessor: 'idGuatemalaFacturacionExistencias',
            Header: 'ID',
            Cell: rowData => {
                const { idGuatemalaFacturacionExistencias } = rowData.row.original;
                return (<span>{idGuatemalaFacturacionExistencias}</span>)
            }
        },
        {
            accessor: 'bIsActive',
            Header: 'Estatus',
            headerProps: { className: 'pe-1' },
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { bIsActive } = rowData.row.original;
                return bIsActive ? (<SoftBadge pill bg='success' className='me-2'>Activo</SoftBadge>) :<SoftBadge pill bg='danger' className='me-2'>No activo</SoftBadge>;
            }
        },
        {
            accessor: 'vNombre',
            Header: 'Nombre',
            headerProps: { className: 'pe-1' },
            cellProps: {
                className: 'py-2'
            },
            Cell: rowData => {
                const { vNombre } = rowData.row.original;
                return (<span >{vNombre}</span>);
            }
        },
        {
            accessor: 'vNit',
            Header: 'NIT',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vNit } = rowData.row.original;
                return (<span> {vNit}</span>)
            }
        },
        {
            accessor: 'vUsuario',
            Header: 'Usuario',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vUsuario } = rowData.row.original;
                return (<span> {vUsuario}</span>)
            }
        },
        {
            accessor: 'vPassword',
            Header: 'Contrasena',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { vPassword } = rowData.row.original;
                return (<span> {btoa(vPassword)}</span>)
            }
        },
        {
            accessor: 'iExistencia',
            Header: 'Existencia',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { iExistencia } = rowData.row.original;
                return (iExistencia < 0 ? <SoftBadge pill bg='success' className='me-2'>Ilimitado</SoftBadge> : <span> {(iExistencia == 0 ? <SoftBadge pill bg='danger' className='me-2'>Sin Existencia</SoftBadge> : iExistencia)}</span>)
            }
        },
        {
            accessor: 'dFechaExpiracion',
            Header: 'Fech. Expiraci\u00F3n',
            cellProps: { className: 'ps-1' },
            Cell: rowData => {
                const { dFechaExpiracion } = rowData.row.original;
                return (dFechaExpiracion == null) ? <SoftBadge pill bg='success' className='me-2' > Sin expiraci&oacute;n</SoftBadge > :
                    <span>

                        {
                            new Date(dFechaExpiracion).toLocaleDateString('es-MX', {
                                year: 'numeric', month: 'short', day: '2-digit'
                            })
                        }

                    </span>
            }
        },
        {
            accessor: 'none',
            Header: '',
            Cell: rowData => {
                const { idGuatemalaFacturacionExistencias } = rowData.row.original;
                return (
                    <>
                        <Row className="flex-end-center">
                            <Col xs="auto" >
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="border-300 text-600"
                                    onClick={() => { ObtenerNITByID(idGuatemalaFacturacionExistencias) }}>
                                    <FontAwesomeIcon icon="edit" />
                                </Button>&nbsp;
                                <Button
                                    variant="light"
                                    size="sm"
                                    className="border-300 text-600"
                                    onClick={() => { ObtenerPlanesDocumentos(idGuatemalaFacturacionExistencias) }}>
                                    <FontAwesomeIcon icon="plus" />
                                </Button>
                            </Col>
                        </Row>
                    </>
                );
            }
        }
    ];
    const { token, setToken } = useToken();
    const { register, setValue, handleSubmit, formState: { errors } } = useForm();
    const { showErrorToast, showSuccessToast } = useToast();

    const [usuariosNube, setNITs] = useState([]);
    const [planesDocumentos, setPlanesDocumentos] = useState([]);

    const [cargando, setCargando] = useState(true);
    const [cargandoDatosParaEditar, setCargandoDatosParaEditar] = useState(true);
    const [showNuevoRuc, setShowNuevoRuc] = useState(false);
    const [showEditarRuc, setShowEditarRuc] = useState(false);
    const [showModalAsignarDTE, setShowModalAsignarDTE] = useState(false);

    const [estatus, setEstatus] = useState(false);

    //Obtener UUID
    const ObtenerCadenaRandom = async (action) => {
        const response = await fetch("/api/licencia/ObtenerCadenaRandom", {
            method: 'GET',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'text/plain'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.text();
            console.log(data);

            if (action == 'Usuario')
                setValue("vUsuario", data);
            else if (action == 'vPassword')
                setValue("vPassword", data);

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    //Solicita los NITs para mostrar la tabla
    const ObtenerCatalogoNITsGuatemala = async () => {
        setCargando(true);
        const response = await fetch("/api/facturaguatemala/ObtenerCatalogoNITsGuatemala",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            setNITs(data);
            setCargando(false);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    //Solicita los paquetes de dte
    const ObtenerPlanesDocumentos = async (idRuc) => {
        setShowModalAsignarDTE(true);
        const response = await fetch("/api/facturaguatemala/ObtenerPlanesDocumentos",
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            setPlanesDocumentos(data);
            setValue("idRuc", idRuc);
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
    };

    //Obtener Informacion de NIT
    const ObtenerNITByID = async (idRuc) => {
        setShowEditarRuc(true);
        setCargandoDatosParaEditar(true);
        const response = await fetch("/api/facturaguatemala/ObtenerNITByID/?_Id=" + idRuc,
            {
                method: 'GET',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            setValue("idGuatemalaFacturacionExistencias", data[0].idGuatemalaFacturacionExistencias);
            setValue("vNombre", data[0].vNombre);
            setValue("vNit", data[0].vNit);
            setValue("vUsuario", data[0].vUsuario);
            setValue("vPassword", data[0].vPassword);
            setValue("bIsActive", data[0].bIsActive);
            setEstatus(data[0].bIsActive);


        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
            console.log(response);
        }
        setCargandoDatosParaEditar(false);
    };

    //Registar NIT 
    const GuardarNIT = async (values) => {
        console.log(values);
        const response = await fetch("/api/facturaguatemala/GuardarNIT/?jsonNIT=" + encodeURIComponent(values), {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();
            console.log(data);

            if (data[0].iResponseType == 1) {
                showSuccessToast(data[0].vMensaje);
            }
            else {
                showErrorToast(data[0].vMensaje);
            }
            ObtenerCatalogoNITsGuatemala();
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowNuevoRuc(false);
        /* Reiniciando */
        setValue("vNit", "");
        setValue("vNombre", "");
        setValue("vUsuario", "");
        setValue("vPassword", "");
    };

    //Registar NIT 
    const EditarInfoNIT = async (key, values) => {
        console.log(values);
        const response = await fetch("/api/facturaguatemala/EditarInfoNIT/?key=" + key + "&jsonNIT=" + encodeURIComponent(values), {
            method: 'PUT',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {

            const data = await response.json();
            console.log(data);

            if (data[0].iResponseType == 1) {
                showSuccessToast(data[0].vMensaje);
            }
            else {
                showErrorToast(data[0].vMensaje);
            }
            ObtenerCatalogoNITsGuatemala();
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
        setShowEditarRuc(false);
        setValue("idGuatemalaFacturacionExistencias", "");
        setValue("vNit", "");
        setValue("vNombre", "");
        setValue("vUsuario", "");
        setValue("vPassword", "");
    };

    //Asingar Paquete de DTE's' 
    const AsignarPaqueteDTE = async (_idPlan, _idRuc) => {
        setShowModalAsignarDTE(false);
        setPlanesDocumentos([]);
        const response = await fetch("/api/facturaguatemala/AsignarPlanANIT/?_idPlan=" + _idPlan + "&_idRuc=" + _idRuc + "", {
            method: 'POST',
            headers:
            {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            console.log('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            console.log(data);
            if (data[0].iResponseType == 1) {
                showSuccessToast(data[0].vMensaje);
            }
            else {
                showErrorToast(data[0].vMensaje);
            }
            ObtenerCatalogoNITsGuatemala();
        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            console.log(response);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };


    const reset = async () => {
        setValue("vNombre", "");
        setValue("vNit", "");
        setValue("vUsuario", "");
        setValue("vPassword", "");
        setValue("bIsActive", true);
        setEstatus(true);
    }

    useEffect(() => {
        ObtenerCatalogoNITsGuatemala();
    }, []);

    const onSubmitNuevoRuc = data => {
        GuardarNIT(JSON.stringify(data));
        console.log(JSON.stringify(data));

    };

    const onSubmitEditarRuc = data => {
        EditarInfoNIT(data.idGuatemalaFacturacionExistencias, JSON.stringify(data));
        console.log(JSON.stringify(data));

    };

    const onSubmitAsignarDTE = data => {
        AsignarPaqueteDTE(data.idGuatemalaFacturasPlanes, data.idRuc);
        console.log(JSON.stringify(data));
    };

    const onCheckedChange = data => {
        console.log(data);
        console.log(data.target.checked);
        setEstatus(data.target.checked);
    }; 

    return (
        <>
            <PageHeader
                title="Documentos Electr&oacute;nicos Tributarios Guatemala"
                image="/img/guatemala96.png"
                className="mb-1"
            >
            </PageHeader>

            <AdvanceTableWrapper
                columns={columns}
                data={usuariosNube}
                sortable
                pagination
                perPage={15}
            >
                <Card className="mb-3">
                    <Card.Header>
                        <Row className="flex-between-center">
                            <Col xs={4} sm="auto" className="d-flex align-items-center pe-0">
                                <div id="orders-actions">

                                    <IconButton
                                        onClick={() => { reset(); setShowNuevoRuc(true); }}
                                        variant="falcon-default"
                                        size="sm"
                                        icon="plus"
                                        transform="shrink-3">
                                        <span className="d-none d-sm-inline-block ms-1" >Nuevo NIT</span>
                                    </IconButton>


                                </div>
                            </Col>
                            <Col xs={6} sm="auto" className="ms-auto ps-0">
                                {!cargando &&
                                    <AdvanceTableSearchBox table />
                                }
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body className="p-0">
                        <AdvanceTable
                            table
                            headerClassName="bg-200 text-900 text-nowrap align-middle"
                            rowClassName="align-middle white-space-nowrap"
                            tableProps={{
                                size: 'sm',
                                striped: true,
                                hover: true,
                                className: 'fs--2 mb-0 overflow-hidden'
                            }}
                        />

                    </Card.Body>
                    <Card.Footer>

                        <AdvanceTableFooter
                            rowCount={usuariosNube.length}
                            table
                            rowInfo
                            navButtons
                            rowsPerPageSelection
                        />
                    </Card.Footer>
                </Card>

            </AdvanceTableWrapper>
            {cargando && (<h3><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</h3>)}
            {showNuevoRuc &&
                <Modal
                    show={showNuevoRuc}
                    onHide={() => setShowNuevoRuc(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmit(onSubmitNuevoRuc)}>
                        <Modal.Header>
                            <Modal.Title>Registra nuevo NIT</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => setShowNuevoRuc(false)} />

                        </Modal.Header>
                        <Modal.Body>
                            <p>Registra un nuevo NIT, de acuerdo a los lineamientos dictados por la Superintendencia de Administraci&oacute;n Tributaria (SAT).</p>

                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>ESTATUS</Form.Label>
                                        <Row>
                                            <Col md={2}>
                                                <Form.Check // prettier-ignore
                                                    {...register("bIsActive",
                                                        {

                                                        })
                                                    }
                                                    type="switch"
                                                    onChange={e => { onCheckedChange(e) }}

                                                />
                                            </Col>
                                            <Col md={10}>
                                                {estatus ?
                                                    <Col>
                                                        <img src="/img/activo.png"></img> <Badge bg="success">Activo</Badge>
                                                    </Col>
                                                    :
                                                    <Col>
                                                        <img src="/img/noactivo.png"></img> <Badge bg="danger">Desactivado</Badge>
                                                    </Col>
                                                }

                                            </Col>
                                        </Row>


                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>NIT</Form.Label>
                                        <Form.Control
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            isInvalid={!!errors.vNit}
                                            {...register("vNit",
                                                {
                                                    required: 'El NIT es requerido',
                                                    maxLength: 13,
                                                    minLength: 1,
                                                    pattern: /([1-9])+([0-9])*([0-9]|K)$/
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vNit && errors.vNit.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Nombre del contribuyente</Form.Label>
                                        <Form.Control
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            isInvalid={!!errors.vNombre}
                                            {...register("vNombre",
                                                {
                                                    required: 'El Nombre es requerido',
                                                    maxLength: 200,
                                                    minLength: 1
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vNombre && errors.vNombre.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Usuario <IconButton
                                            className="ms-2"
                                            iconClassName="fs--2 me-1"
                                            variant="falcon-primary"
                                            size="sm"
                                            icon="circle"
                                            onClick={() => { ObtenerCadenaRandom('Usuario') }}
                                        >
                                            Generar
                                        </IconButton></Form.Label>
                                        <Form.Control
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            isInvalid={!!errors.vUsuario}
                                            {...register("vUsuario",
                                                {
                                                    required: 'El usuario es requerido',
                                                    maxLength: 40,
                                                    minLength: 1
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vUsuario && errors.vUsuario.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Contrase&ntilde;a <IconButton
                                            className="ms-2"
                                            iconClassName="fs--2 me-1"
                                            variant="falcon-primary"
                                            size="sm"
                                            icon="circle"
                                            onClick={() => { ObtenerCadenaRandom('vPassword') }}
                                        >
                                            Generar
                                        </IconButton></Form.Label>
                                        <Form.Control
                                            onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                            isInvalid={!!errors.vPassword}
                                            {...register("vPassword",
                                                {
                                                    required: 'La contrase\u00F1a es requerido',
                                                    maxLength: 40,
                                                    minLength: 1
                                                })
                                            }
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.vPassword && errors.vPassword.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => { setShowNuevoRuc(false) }} variant='primary' >Cerrar</Button>
                            <Button type="submit" variant='success' >Registrar</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            }
            {showEditarRuc &&
                <Modal
                    show={showEditarRuc}
                    onHide={() => { reset(); setShowEditarRuc(false) }}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmit(onSubmitEditarRuc)}>
                        <Modal.Header>
                            <Modal.Title>Editar NIT</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => { reset(); setShowEditarRuc(false) }} />

                        </Modal.Header>
                        <Modal.Body>
                            <p>En este formulario es posible editar los datos vinculados al NIT, sin embargo, el NIT no podr&aacute; ser editado.</p>
                            {cargandoDatosParaEditar ?
                                <span><Spinner className="text-inline" animation="border" variant="primary" /> Cargando...</span> :
                                <Row>
                                    <Col md={12}>
                                        <Form.Control
                                            type="hidden"
                                            isInvalid={!!errors.idGuatemalaFacturacionExistencias}
                                            {...register("idGuatemalaFacturacionExistencias")
                                            }
                                        />


                                        <Form.Group className="mb-3">
                                            <Form.Label>ESTATUS</Form.Label>
                                            <Row>
                                                <Col md={2}>
                                                    <Form.Check // prettier-ignore
                                                        {...register("bIsActive",
                                                            {

                                                            })
                                                        }
                                                        type="switch"
                                                        onChange={e => { onCheckedChange(e) }}

                                                    />
                                                </Col>
                                                <Col md={10}>
                                                    {estatus &&
                                                        <Col>
                                                            <img src="/img/activo.png"></img> <Badge bg="success">Activo</Badge>
                                                        </Col>
                                                    }

                                                    {!estatus &&
                                                        <Col>
                                                            <img src="/img/noactivo.png"></img> <Badge bg="danger">Desactivado</Badge>
                                                        </Col>
                                                    }

                                                </Col>
                                            </Row>


                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>NIT</Form.Label>
                                            <Form.Control
                                                disabled
                                                isInvalid={!!errors.vNit}
                                                {...register("vNit",
                                                    {
                                                        required: 'El NIT es requerido',
                                                        maxLength: 13,
                                                        minLength: 1,
                                                        pattern: /([1-9])+([0-9])*([0-9]|K)$/
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vNit && errors.vNit.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Nombre del contribuyente</Form.Label>
                                            <Form.Control
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                isInvalid={!!errors.vNombre}
                                                {...register("vNombre",
                                                    {
                                                        required: 'El Nombre es requerido',
                                                        maxLength: 200,
                                                        minLength: 1
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vNombre && errors.vNombre.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Usuario <IconButton
                                                className="ms-2"
                                                iconClassName="fs--2 me-1"
                                                variant="falcon-primary"
                                                size="sm"
                                                icon="circle"
                                                onClick={() => { ObtenerCadenaRandom('Usuario') }}
                                            >
                                                Generar
                                            </IconButton></Form.Label>
                                            <Form.Control
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                isInvalid={!!errors.vUsuario}
                                                {...register("vUsuario",
                                                    {
                                                        required: 'El usuario es requerido',
                                                        maxLength: 40,
                                                        minLength: 1
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vUsuario && errors.vUsuario.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Contrase&ntilde;a <IconButton
                                                className="ms-2"
                                                iconClassName="fs--2 me-1"
                                                variant="falcon-primary"
                                                size="sm"
                                                icon="circle"
                                                onClick={() => { ObtenerCadenaRandom('vPassword') }}
                                            >
                                                Generar
                                            </IconButton></Form.Label>
                                            <Form.Control
                                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                                isInvalid={!!errors.vPassword}
                                                {...register("vPassword",
                                                    {
                                                        required: 'La contrase\u00F1a es requerido',
                                                        maxLength: 40,
                                                        minLength: 1
                                                    })
                                                }
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.vPassword && errors.vPassword.message}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            }
                        </Modal.Body>
                        <Modal.Footer>

                            <Button onClick={() => { reset(); setShowEditarRuc(false) }} variant='primary' >Cerrar</Button>
                            {!cargandoDatosParaEditar && <Button type="submit" variant='success' >Registrar</Button>}
                        </Modal.Footer>
                    </Form>
                </Modal>
            }
            {showModalAsignarDTE &&
                <Modal
                    show={showModalAsignarDTE}
                    onHide={() => setShowModalAsignarDTE(false)}
                    size="md"
                    backdrop="static"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                >
                    <Form noValidate onSubmit={handleSubmit(onSubmitAsignarDTE)}>
                        <Modal.Header>
                            <Modal.Title>Asingar plan</Modal.Title>
                            <FalconCloseButton className="btn btn-circle btn-sm transition-base p-0" onClick={() => setShowModalAsignarDTE(false)} />

                        </Modal.Header>
                        <Modal.Body>
                            <Row>
                                <Col>
                                    Debes elegir un paquete para asignar al NIT seleccionado.
                                    <hr></hr>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Control
                                        type="hidden"
                                        isInvalid={!!errors.idRuc}
                                        {...register("idRuc")
                                        }
                                    />
                                    <Form.Group className="mb-3" >
                                        <Form.Label>Paquete DTE's</Form.Label>
                                        <Form.Select
                                            aria-label="Default select"
                                            defaultValue=""
                                            isInvalid={!!errors.idGuatemalaFacturasPlanes}
                                            {...register("idGuatemalaFacturasPlanes",
                                                {
                                                    required: true
                                                })
                                            }
                                        >
                                            <option value="">Selecciona un paquete</option>
                                            {planesDocumentos.map((plan, index) => {
                                                return (<option key={index} value={plan.idGuatemalaFacturasPlanes}>{plan.vPlanTitle} - {(plan.dCantidad == -1) ? "Ilimitados" : plan.dCantidad} DTE's - ${plan.dPlanPrice}USD</option>)
                                            })}
                                        </Form.Select>
                                        <Form.Control.Feedback type="invalid">
                                            {errors.idGuatemalaFacturasPlanes && errors.idGuatemalaFacturasPlanes.message}
                                        </Form.Control.Feedback>
                                    </Form.Group>

                                </Col>
                            </Row>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => { setShowModalAsignarDTE(false) }} variant='primary' >Cerrar</Button>
                            <Button type="submit" variant='success' >ASIGNAR PLAN</Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            }
        </>
    );
};

export default FacturaDocumentosGuatemala;
